import { create } from 'zustand';
import { ApiUtils, CardApi, CardEntity, RequestStrategyEnum } from '@shared/api';

interface IUnblockCardStore {
  loading: boolean;
  error: string | null;
  card: CardEntity[];
  unblockCard: (accountId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useUnblockCardStore = create<IUnblockCardStore>((set) => ({
  loading: false,
  error: null,
  card: [],

  unblockCard: ApiUtils.wrapperApi(async (accountId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await CardApi.unblockCard(accountId, signal);
      set({ card: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ card: [], loading: false, error: null }),
}));
